<template>
    <v-layout>
        <v-flex xs12>
            <v-card class="mx-auto" flat>
                <confirmation-header-text :text="$vuetify.lang.t('$vuetify.business_detail')" class="ml-0"
                                          icon="mdi-alpha-b-box"/>
                <v-card-text class="pt-3 pb-0">
                    <v-layout row>
                        <v-flex sm6 xs12 class="pr-2">
                            <v-text-field
                                    :label="$vuetify.lang.t('$vuetify.name_of_business_institute') + ' *'"
                                    :rules="[rules.required]"
                                    outlined
                                    type="text"
                                    v-model="visa.extra.application_data.name_of_business_institute"
                            />
                        </v-flex>

                        <v-flex sm6 xs12>
                            <address-auto-complete
                                    :label="$vuetify.lang.t('$vuetify.address_of_institution') + ' *'"
                                    :rules="[rules.required]"
                                    country-code="np"
                                    v-model="visa.extra.application_data.address_of_business_institute"
                            />
                        </v-flex>

                        <v-flex class="pr-5 pl-3 pb-5" md6 xs12>
                            <date-picker-new
                                    :for-passport="true"
                                    label="Business Duration From *"
                                    v-model="visa.extra.application_data.business_from"
                            />
                        </v-flex>
                        <v-flex class="pl-3 pr-3 pb-5" md6 xs12>
                            <date-picker-new
                                    :for-passport="true"
                                    label="Business Duration To *"
                                    v-model="visa.extra.application_data.business_to"
                            />
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import AddressAutoComplete from "../../AddressAutoComplete";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";
    import DatePicker from "../../DatePicker";
    import DatePickerNew from "../../DatePickerNew";

    export default {
        data: () => ({
            addressLoading: false,
            rules: {
                required: value => !!value || "Required."
            },
        }),
        components: {
            DatePickerNew,
            DatePicker, ConfirmationHeaderText,
            "address-auto-complete": AddressAutoComplete
        },
        computed: {
            visa() {
                return this.$store.state.VisaSingle.visa;
            }
        },

    };
</script>

<style>
</style>
